import { confirmable, ConfirmDialog, createConfirmation } from "react-confirm";

import { DeleteConfirmation } from "@/Components/v2/molecule/ConfirmationDialog";

interface DeleteActionPlanConfirmationProps {
  actionPlanName: string;
}

const DeleteActionPlanDialog: ConfirmDialog<DeleteActionPlanConfirmationProps, boolean> = ({
  show,
  proceed,
  actionPlanName,
}) => (
  <DeleteConfirmation
    open={show}
    title="Delete Action Plan?"
    subtitle={`Are you sure you want to delete Action Plan "${actionPlanName}". This cannot be undone.`}
    deleteButtonText="Delete"
    cancelButtonText="Go Back"
    onDelete={() => proceed(true)}
    onCancel={() => proceed(false)}
  />
);

const ConfirmableDialog = confirmable(DeleteActionPlanDialog);

export const confirmDeleteActionPlan = createConfirmation(ConfirmableDialog);
